import React from 'react';
import { CheckCircle2, AlertTriangle, XCircle } from 'lucide-react';
export function IngredientCategories() {
  return <section className="py-20 bg-white" data-id="element-716">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-717">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-718">
          <h2 className="text-3xl sm:text-4xl font-black text-slate-900 mb-4" data-id="element-719">
            Understanding Ingredient Categories
          </h2>
          <p className="text-lg text-slate-600" data-id="element-720">
            To make scanning as intuitive as possible, IntelliEats sorts every
            detected ingredient into three simple, color-coded categories.
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-8" data-id="element-721">
          <div className="bg-green-50 rounded-2xl p-8 border border-green-100" data-id="element-722">
            <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mb-6" data-id="element-723">
              <CheckCircle2 className="w-6 h-6 text-green-600" data-id="element-724" />
            </div>
            <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-725">
              Safe Ingredients
            </h3>
            <p className="text-slate-700 leading-relaxed" data-id="element-726">
              Marked in green, these are generally recognized as safe (GRAS) by
              food authorities. They include whole foods, natural spices,
              standard vitamins, and benign additives like citric acid. When you
              see a list full of green, you can feel confident that the product
              is made from recognizable, non-toxic components.
            </p>
          </div>
          <div className="bg-yellow-50 rounded-2xl p-8 border border-yellow-100" data-id="element-727">
            <div className="w-12 h-12 bg-yellow-100 rounded-full flex items-center justify-center mb-6" data-id="element-728">
              <AlertTriangle className="w-6 h-6 text-yellow-600" data-id="element-729" />
            </div>
            <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-730">
              Limited Intake
            </h3>
            <p className="text-slate-700 leading-relaxed" data-id="element-731">
              Marked in amber, these ingredients aren't strictly toxic, but they
              should be consumed in moderation. This category catches added
              sugars, excessive sodium, refined carbohydrates, and certain
              flavor enhancers like MSG. It serves as a gentle warning to
              balance this food with healthier choices throughout your day.
            </p>
          </div>
          <div className="bg-red-50 rounded-2xl p-8 border border-red-100" data-id="element-732">
            <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mb-6" data-id="element-733">
              <XCircle className="w-6 h-6 text-red-600" data-id="element-734" />
            </div>
            <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-735">
              Ingredients to Avoid
            </h3>
            <p className="text-slate-700 leading-relaxed" data-id="element-736">
              Marked in red, these are the red flags. This category includes
              artificial trans fats, controversial food dyes, chemical
              preservatives like sodium benzoate, and artificial sweeteners that
              have been linked to adverse health effects. If a product has
              multiple red ingredients, it's usually best to leave it on the
              shelf.
            </p>
          </div>
        </div>
      </div>
    </section>;
}